/**
 * SOVEREIGN SOCIAL MATRIX — Master Social Seal (10 anchors)
 * Architect-confirmed URLs. Single source of truth for:
 *   1. Footer social strip (OldMindsAffiliatesStrip.jsx)
 *   2. Body Connect block (SovereignSocialConnect.jsx)
 *   3. SEO Open Graph og:see_also + JSON-LD sameAs (public/index.html)
 * Order below is the definitive display + SEO order.
 */
export const SOVEREIGN_SOCIAL = [
  {
    id: 'x-personal',
    platform: 'X',
    name: 'Roger Keyserling',
    tagline: 'The Architect · 𝕏',
    href: 'https://x.com/keyserlingroger',
    initial: '𝕏',
    ringFrom: 'from-slate-300',
    ringTo: 'to-slate-500',
  },
  {
    id: 'x-business',
    platform: 'X',
    name: 'NextXus Federation',
    tagline: 'Organization · 𝕏',
    href: 'https://x.com/NextxusFederati',
    initial: '𝕏',
    ringFrom: 'from-slate-200',
    ringTo: 'to-cyan-500',
  },
  {
    id: 'instagram-keyhole',
    platform: 'Instagram',
    name: 'Keyhole Today',
    tagline: 'Instagram',
    href: 'https://instagram.com/keyhole_today',
    initial: 'IG',
    ringFrom: 'from-pink-500',
    ringTo: 'to-fuchsia-600',
  },
  {
    id: 'instagram-rkeyserling',
    platform: 'Instagram',
    name: 'R. Keyserling',
    tagline: 'Instagram',
    href: 'https://instagram.com/rkeyserling',
    initial: 'IG',
    ringFrom: 'from-orange-400',
    ringTo: 'to-pink-600',
  },
  {
    id: 'facebook-roger',
    platform: 'Facebook',
    name: 'Roger Keyserling',
    tagline: 'Facebook',
    href: 'https://facebook.com/roger.keyserling.35',
    initial: 'f',
    ringFrom: 'from-blue-500',
    ringTo: 'to-indigo-600',
  },
  {
    id: 'facebook-hub',
    platform: 'Facebook',
    name: 'Federation Hub',
    tagline: 'Facebook',
    href: 'https://facebook.com/profile.php?id=61560731046964',
    initial: 'f',
    ringFrom: 'from-blue-400',
    ringTo: 'to-indigo-500',
  },
  {
    id: 'facebook-media',
    platform: 'Facebook',
    name: 'NextXus Media',
    tagline: 'Facebook',
    href: 'https://facebook.com/profile.php?id=61559858694086',
    initial: 'f',
    ringFrom: 'from-sky-500',
    ringTo: 'to-blue-600',
  },
  {
    id: 'facebook-community',
    platform: 'Facebook',
    name: 'NextXus Community',
    tagline: 'Facebook',
    href: 'https://facebook.com/profile.php?id=61559981881665',
    initial: 'f',
    ringFrom: 'from-indigo-500',
    ringTo: 'to-blue-700',
  },
  {
    id: 'facebook-network',
    platform: 'Facebook',
    name: 'NextXus Network',
    tagline: 'Facebook',
    href: 'https://facebook.com/profile.php?id=61558223610996',
    initial: 'f',
    ringFrom: 'from-cyan-500',
    ringTo: 'to-blue-600',
  },
  {
    id: 'linkedin',
    platform: 'LinkedIn',
    name: 'Roger Keyserling',
    tagline: 'LinkedIn',
    href: 'https://linkedin.com/in/roger-keyserling-ab743698',
    initial: 'in',
    ringFrom: 'from-sky-500',
    ringTo: 'to-blue-700',
  },
];
